"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _browserRum = require("@datadog/browser-rum");
var _DebugManager = _interopRequireDefault(require("./DebugManager"));
var _RUMUtil;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var dmInstance = _DebugManager["default"].dmInstance;
var RUMUtil = exports["default"] = /*#__PURE__*/_createClass(function RUMUtil() {
  _classCallCheck(this, RUMUtil);
});
_RUMUtil = RUMUtil;
/**
* initiate Datadog RUM - WN-3746
*
* @param  {string} appName
*         application name - required
* @param  {object} opts
*         optional and merged with config object
*/
_defineProperty(RUMUtil, "init", function (appName, opts) {
  if (!appName) return;
  try {
    var ddConfig = _objectSpread(_objectSpread({}, _RUMUtil.DatadogConfig[appName.toUpperCase()]), opts);
    _browserRum.datadogRum.init(ddConfig);
    dmInstance.log("[RUMUtil] init() Datadog RUM initialized with: ".concat(JSON.stringify(ddConfig)));
  } catch (e) {
    dmInstance.log("[RUMUtil] init() Datadog RUM error: ".concat(e));
  }
});
/**
* start datadog session replay
*
*/
_defineProperty(RUMUtil, "startSessionReplay", function () {
  try {
    _browserRum.datadogRum.startSessionReplayRecording();
  } catch (e) {
    dmInstance.log("[RUMUtil] startSessionReplay() Datadog RUM error: ".concat(e));
  }
});
/**
* set user data Datadog RUM - WN-3746
*
* @param  {object} user
*         user data - required
*/
_defineProperty(RUMUtil, "setUser", function (user) {
  try {
    var userName = "".concat(user.firstName, " ").concat(user.lastName);
    _browserRum.datadogRum.setUser({
      id: user.id,
      name: userName,
      accountId: user.accountId
    });
    dmInstance.log("[RUMUtil] setUser() userId: ".concat(user.id, ", userName: ").concat(userName, ", accountId: ").concat(user.accountId));
  } catch (e) {
    dmInstance.log("[RUMUtil] setUser() Datadog RUM error: ".concat(e));
  }
});
/**
* set context Datadog RUM - WN-3746
*
* @param  {object} context
*         event context - required
*/
_defineProperty(RUMUtil, "setContext", function (context) {
  try {
    _browserRum.datadogRum.addRumGlobalContext('eventData', context);
    dmInstance.log("[RUMUtil] setContext() context: ".concat(JSON.stringify(context)));
  } catch (e) {
    dmInstance.log("[RUMUtil] setContext() Datadog RUM error: ".concat(e));
  }
});
/**
* add action Datadog RUM
*
* @param  {string} name
*         action name - required
* @param  {object} actionObj
*         action object - required
*/
_defineProperty(RUMUtil, "addAction", function (name, actionObj) {
  try {
    _browserRum.datadogRum.addAction(name, actionObj);
  } catch (e) {
    dmInstance.log("[RUMUtil] addAction() Datadog RUM error: ".concat(e));
  }
});
/**
* add error Datadog RUM
*
* @param  {object} error
*         Error object - required
* @param  {object} context
*         context object - optional
*/
_defineProperty(RUMUtil, "addError", function (error) {
  var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  try {
    _browserRum.datadogRum.addError(error, context);
  } catch (e) {
    dmInstance.log("[RUMUtil] addError() Datadog RUM error: ".concat(e));
  }
});
// Datadog RUM config
_defineProperty(RUMUtil, "DatadogConfig", {
  BACKSTAGE: {
    name: 'backstage',
    applicationId: 'd890359a-ecad-4c7e-a0b3-6565d238865c',
    clientToken: 'pube24cf13cb75da1e96b3793e9c7ceec92',
    service: 'broadcaster-backstage',
    site: 'datadoghq.com',
    env: 'dev',
    version: '1.0.0',
    trackInteractions: true
  },
  AUDIENCE: {
    name: 'audience',
    applicationId: '9cdf52b4-edd8-4709-bfa9-a84f9179f7fb',
    clientToken: 'pub257caf4ba6144ab280ee8c888e09a46b',
    service: 'broadcaster-audience',
    site: 'datadoghq.com',
    env: 'dev',
    version: '1.0.0',
    trackInteractions: true
  }
});